import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useClientAuth } from '../../contexts/ClientAuthContext';
import { InstallationProvider } from '../../contexts/InstallationContext';
import PortalHeader from './PortalHeader';
import LoadingSpinner from '../common/LoadingSpinner';

const PortalLayout: React.FC = () => {
  const { isAuthenticated, loading } = useClientAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !isAuthenticated) {
      navigate('/portal/login', { replace: true });
    }
  }, [isAuthenticated, loading, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return null;
  }

  return (
    <InstallationProvider>
      <div className="min-h-screen bg-gray-50">
        <PortalHeader />
        <main className="max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <Outlet />
        </main>
      </div>
    </InstallationProvider>
  );
};

export default PortalLayout;
